export const showLeftEllipsis = (pageCount, shownMidPages) => {
    return pageCount >= 5 && shownMidPages.length > 0 && shownMidPages[0] !== 3;
};
export const showRightEllipsis = (pageCount, shownMidPages) => {
    /* The right ellipsis would never logically appear unless there are at least 6 pages */
    return (pageCount >= 6 &&
        shownMidPages.length > 0 &&
        shownMidPages[shownMidPages.length - 1] !== pageCount - 2);
};
export const middlePagesToShow = (pageCount, currentPage, optionCount = 7) => {
    // Subtract 4 for the first and last page and the two ellipses
    const modifier = Math.ceil((optionCount - 4 - 1) / 2);
    let startPage = currentPage - modifier;
    // If the amount of options is even, then we show one less to the right of the current selection
    let endPage = currentPage + (modifier - (optionCount % 2 === 0 ? 1 : 0));
    if (startPage <= 2) {
        const newEndPage = endPage + (3 - startPage);
        endPage = newEndPage <= pageCount - 2 ? newEndPage : pageCount - 2;
        startPage = 3;
    }
    if (endPage >= pageCount - 1) {
        const newStartPage = startPage - (endPage - (pageCount - 2));
        startPage = newStartPage >= 3 ? newStartPage : 3;
        endPage = pageCount - 2;
    }
    const totalMiddlePagesToShow = endPage - startPage + 1 >= 0 ? endPage - startPage + 1 : 0;
    return Array.from(Array(totalMiddlePagesToShow)).map((v, index) => index + startPage);
};
//# sourceMappingURL=utils.js.map